import { createSelector } from '@reduxjs/toolkit';

import favoritesDataSelector from './data';

export const countSelector = createSelector(
  favoritesDataSelector,
  favoritesData => favoritesData.data?.total,
);

export default countSelector;
